// Job cards (step-by-step instructions) for every division.
// Each file in ./jobCardsData exports { division, cards } and is loaded automatically,
// so adding a division's file to that folder is enough.
// Job codes repeat across divisions (e.g. M1, F1), so a card is always found by division + code.

const files = require.context('./jobCardsData', false, /\.js$/);

export const JOB_CARDS = {};
files.keys().forEach((key) => {
  const { division, cards } = files(key);
  if (division && cards) JOB_CARDS[division] = { ...(JOB_CARDS[division] || {}), ...cards };
});

// "O1 - Onboard a new client" -> "O1"
export const getJobCode = (jobName) => {
  const match = /^([A-Z]+\d+)\s+-\s+/.exec(jobName || "");
  return match ? match[1] : null;
};

// Card for a division + job name, or null if there is none (Other, no job picked, card not added yet).
export const getJobCard = (divisionName, jobName) => {
  const code = getJobCode(jobName);
  if (!code) return null;
  const division = JOB_CARDS[divisionName];
  return division && division[code] ? division[code] : null;
};
